<template>
  <div class="content content--news-single">
    <OverlayLoader v-if="!$store.getters.newsSingleLoaded"></OverlayLoader>
    <MyHeader :breadcrumbItems="breadcrumbItems "/>
    <header class="content-header d-lg-none">
      <h1>{{news.headline}}</h1>
    </header>

    <div class="container main-content">
      <div class="hero--gtm">
        <div class="hero-img">
          <VideoWrapper v-if="news.videoURL" :videoLink="news.videoURL"></VideoWrapper>
          <ImageWrapper :file="news.idFile" :key="news.idFile"></ImageWrapper>
        </div>
        <div class="hero-content">
          <span class="hero-tag">
            <span>{{news.date | formatDate2}}</span>
            <span v-if="news._embedded.Content.importSource">{{news._embedded.Content.importSource}}</span>
            <span>{{readTime(news.contentNew)}} minute read</span>
          </span>
          <Bookmark :contentId="news.idContent"></Bookmark>
          <span class="hero-title">{{news.headline}}</span>
          <div class="buttons">
            <button class="button-icon button--submit" v-if="!userLiked" @click="toggleVote">Like <i class="icon-vote-up"></i></button>
            <button class="button-icon button--dark" v-else @click="toggleVote">Unlike <i class="icon-vote-down"></i></button>
            <button class="button-icon" @click="goToComment">Comment <i class="icon-comment"></i></button>
          </div>
        </div>
      </div>

      <div class="article-content row" style="padding-bottom: 40px">
        <div class="col-lg-10 offset-lg-1" v-html="openLinksInNewTab(news.contentNew)"></div>
        <div class="col-lg-10 offset-lg-1"><a @click="trackOpenNewExternalLink" :href="news.URL" target="_blank">{{news.URLDescription ? news.URLDescription : news.URL}}</a></div>
      </div>

      <div class="main-content-bottom2 row" v-if="news._embedded.TeamMembers">
        <div class="col-lg-10 offset-lg-1">
          <div class="main-content-bottom2-title">Contact</div>
          <div class="row">
            <ContactInfo :contact="contact" v-for="contact in news._embedded.TeamMembers" :key="contact.idContent"></ContactInfo>
          </div>
        </div>
      </div>
    </div>

    <Comments :key="news.idContent"></Comments>
  </div>
</template>

<script>
import $ from 'jquery'
import {openLinksInNewTab} from "@/helpers/openLinksInNewTab"
import MyHeader from '../../components/general/Header'
import ImageWrapper from "@/components/general/ImageWrapper";
import api from "@/api/ideas";
import ContactInfo from "@/components/persons/ContactInfo";
import Comments from "@/components/comments/Comments";
import OverlayLoader from "@/components/general/OverlayLoader";
import {readTime} from "@/helpers/readTime";
import settings from "@/settings";
import Bookmark from "@/components/general/Bookmark";
import VideoWrapper from "@/components/general/VideoWrapper";
import userApi from "@/api/user";
export default {
  name: "NewsSingle",
  components: {VideoWrapper, Bookmark, OverlayLoader, Comments, ContactInfo, ImageWrapper, MyHeader},
  data () {
    return {
      liked: false
    }
  },
  computed: {
    news() {
      return this.$store.getters.newsSingle
    },
    section() {
      return this.$store.getters.sectionByCode(settings.MODULES.NEWS)
    },
    userLiked() {
      return this.news._embedded.UserContentReaction.some((reaction) => {
        return reaction.idUser === this.$store.getters.user.idUser
      })
    },
    breadcrumbItems() {
      if(!this.section) {
       return [
          {
            name: this.news.headline,
            path: this.$route.path
          },
        ]
      }
      return [

        {
          name: this.section.value,
          path: `/${this.$route.params.companySlug}/news`
        },
        {
          name: this.news.headline,
          path: this.$route.path
        },
      ]
    }
  },
  mounted() {
    this.getNews()
  },
  watch: {
    '$route.params.id'() {
      this.getNews()
      this.$nextTick(() => {
        let mainDiv = document.getElementsByClassName("content--news-single");
        if(mainDiv) {
          mainDiv[0].scrollIntoView({behavior: 'smooth'})
        }
      })
    },
    '$store.getters.newsSingleLoaded' (val) {
      if(val) {
        window._paq.push(['setDocumentTitle', this.news.headline]);
        window._paq.push(['trackPageView']);
        userApi.logUserAccessContent({
          "idContent": this.news.idContent,
          "idUser": this.$store.getters.user.idUser,
          "idUserAccessContent":""
        })
      }
    }
  },
  methods: {
    readTime: readTime,
    openLinksInNewTab: openLinksInNewTab,
    getNews() {
      this.$store.dispatch('getSingleNews', this.$route.params.id)
    },
    goToComment () {
      let offset = $('.section--idea-comments').offset().top
      $('html, body').animate({ scrollTop: offset }, 500)
    },
    toggleVote () {
      this.voted = false;
      let data = {
        idUser: this.$store.getters.user.idUser,
        idContent: this.news.idContent,
        type: 'LIKE',
        deleteReaction: this.userLiked ? 1 : null
      }
      api.addReaction(data, response => {
        this.liked = false;
        if(response.idUser) {
          this.liked = true;
        }
        this.getNews();
      })
    },
    trackOpenNewExternalLink(){
      this.$gtag.event('OpenNewExternalLink', {
        'event_category': this.$store.getters.company.name,
        'company_name': this.$store.getters.company.name,
        'event_label': this.section.name,
        'value': this.news.headline
      })
    }
  }
}
</script>
